import { createAction, createSlice } from '@reduxjs/toolkit';

export type RewardsData = {
	'employeeName': string,
	'imageUrl': string,
	'description': string,
	'dateOfJoining': string,
	'buzzBoardId': string,
	'buzzType': string,

}

const initialState: RewardsData[] = [];

export const revertAll = createAction('REVERT_ALL');

export const rewardsReducer = createSlice({
	name: 'rewardsReducer',
	initialState,
	reducers: {
		setRewardsData: (state, action) => {
			state = action.payload;
			return state;
		},
		addRewardsData: (state, action) => {
			state = [action.payload, ...state];
			return state;
		},
		updateRewardsData: (state, action) => {

			const indexOfReportToChange = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);
			const changedRewardsData = action.payload;

			state[indexOfReportToChange] = changedRewardsData;
			return state;
		},
		deleteRewardsData: (state, action) => {

			const indexOfRewardsDataToDelete = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);

			if (indexOfRewardsDataToDelete !== -1) {

				const savedData = state;
				state = [
					...savedData.slice(0, indexOfRewardsDataToDelete),
					...savedData.slice(indexOfRewardsDataToDelete + 1)];
			}
			return state;
		}

	}

});
export const { setRewardsData, addRewardsData, updateRewardsData, deleteRewardsData } = rewardsReducer.actions;
export default rewardsReducer;
